export function renderLoadmoreItem(data){
    //0 - спектакли
    //1 - новости
    //2 - проекты (поэтомания)
    //3 - мы в сми

    let result = '';
            data.result.forEach(info => {
                result += `
                  <div class="item">
          <div class="type">${info.type}</div>
          <div class="image lozad" data-background="${info.image}"></div>
          <div class="text-block">
            <div class="caption">${info.data}</div>
            <div class="headline">${info.text}</div>
          </div>
        </div>`;
            });

    return result;
}